import type { ExportSection } from './csv'

// exceljs is dynamically imported by the caller's click handler (same pattern
// as InvoicePDF in InvoicesPage.tsx) — keeps it out of the initial bundle.
export async function downloadXlsx(filename: string, sections: ExportSection[]) {
  const ExcelJS = await import('exceljs')
  const workbook = new ExcelJS.Workbook()

  for (const section of sections) {
    // Sheet names are capped at 31 chars and can't contain []*?:/\ — titles here are short and plain.
    const sheet = workbook.addWorksheet(section.title.slice(0, 31))
    sheet.addRow(section.headers).font = { bold: true }
    for (const row of section.rows) sheet.addRow(row)
    sheet.columns.forEach((col) => { col.width = 24 })
  }

  const buffer = await workbook.xlsx.writeBuffer()
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.click()
  URL.revokeObjectURL(url)
}
